/**
 * Standard button props for list/detail pages (light & dark).
 * Use these spreads so the same action always uses the same variant, color, and size.
 */

export const PAGE_BUTTON_SIZE = "medium" as const;

/** Primary CTA in page headers: Create / Add / Analyze */
export const pageButtonPrimaryProps = {
  variant: "contained" as const,
  color: "primary" as const,
  size: PAGE_BUTTON_SIZE,
};

/** Cancel / Close / Back — outlined, inherits theme text & border */
export const pageButtonCancelProps = {
  variant: "outlined" as const,
  color: "inherit" as const,
  size: PAGE_BUTTON_SIZE,
};

/** Save / Submit success — page-level actions */
export const pageButtonSaveSuccessProps = {
  variant: "contained" as const,
  color: "success" as const,
  size: PAGE_BUTTON_SIZE,
};

const DRAWER_BUTTON_SIZE = "small" as const;

/** Matches filter-header refresh control height and subtitle2 type. */
export const FILTER_HEADER_ACTION_HEIGHT = 30;

export const filterHeaderActionSx = {
  textTransform: "none" as const,
  fontWeight: 700,
  fontSize: "0.875rem",
  lineHeight: 1.2,
  minHeight: FILTER_HEADER_ACTION_HEIGHT,
  height: FILTER_HEADER_ACTION_HEIGHT,
  px: 1.25,
  py: 0,
  boxShadow: "none",
  flexShrink: 0,
};

/** Right-panel Cancel — compact Microsoft form footer */
export const drawerButtonCancelProps = {
  variant: "outlined" as const,
  color: "inherit" as const,
  size: DRAWER_BUTTON_SIZE,
};

/** Right-panel primary Save / Submit */
export const drawerButtonSaveProps = {
  variant: "contained" as const,
  color: "primary" as const,
  size: DRAWER_BUTTON_SIZE,
};

/** Destructive confirm — delete, cancel subscription, etc. */
export const pageButtonDangerProps = {
  variant: "contained" as const,
  color: "error" as const,
  size: PAGE_BUTTON_SIZE,
};

/** Secondary outline — Search, Go to page, lookup */
export const pageButtonOutlinedPrimaryProps = {
  variant: "outlined" as const,
  color: "primary" as const,
  size: PAGE_BUTTON_SIZE,
};

/** Inline destructive in lists (less emphasis than dialog danger) */
export const pageButtonOutlinedDangerProps = {
  variant: "outlined" as const,
  color: "error" as const,
  size: PAGE_BUTTON_SIZE,
};

/** File upload trigger (still a button visually) */
export const pageButtonUploadProps = {
  variant: "outlined" as const,
  color: "success" as const,
  size: PAGE_BUTTON_SIZE,
  component: "span" as const,
};
